export default {
  appVersion: {
    api: 1,
    major: 1,
    minor: 0,
    patch: 0,
  },
};
